export const SET_ESG_COMPLIANCE_ASSESSMENT_DETAILS =
  "SET_ESG_COMPLIANCE_ASSESSMENT_DETAILS";
export const SET_ORIGINAL_ESG_COMPLIANCE_ASSESSMENT_DETAILS =
  "SET_ORIGINAL_ESG_COMPLIANCE_ASSESSMENT_DETAILS";
export const SET_SELECTED_COMPLIANCE_ROW_DATA =
  "SET_SELECTED_COMPLIANCE_ROW_DATA";
export const SET_ESG_COMPLIANCE_STRUCTURED_REPORT_DATA =
  "SET_ESG_COMPLIANCE_STRUCTURED_REPORT_DATA";
export const SET_ESG_COMPLIANCE_FILTERED_REPORT_DATA =
  "SET_ESG_COMPLIANCE_FILTERED_REPORT_DATA";
export const SET_ESG_COMPLIANCE_STRUCTURED_AUDIT_REPORT_DATA =
  "SET_ESG_COMPLIANCE_STRUCTURED_AUDIT_REPORT_DATA";
export const SET_ESG_COMPLIANCE_FILTERED_AUDIT_REPORT_DATA =
  "SET_ESG_COMPLIANCE_FILTERED_AUDIT_REPORT_DATA";
  //constant for filter 
 export const UPDATE_CHECKED_ITEMS = "UPDATE_CHECKED_ITEMS";
export const UPDATE_MAIN_TOPIC_ID = "UPDATE_MAIN_TOPIC_ID";
export const UPDATE_SUB_SUB_SECTION_ID = "UPDATE_SUB_SUB_SECTION_ID";
export const UPDATE_FILTER_STATUS = "UPDATE_FILTER_STATUS";
export const UPDATE_CONTRIBUTOR_IDS = "UPDATE_CONTRIBUTOR_IDS";
export const UPDATE_APPROVER_IDS = "UPDATE_APPROVER_IDS";
export const CLEAR_ALL_FILTERS = "CLEAR_ALL_FILTERS";

